import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/Home/HomeViews.vue')
  },
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
      
    }
    if (to.hash) {
      return{
        el:to.hash,
        behavior:'smooth'
      }
      
      
    }
  }
})

export default router
